module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/aqD6qe/tc-custom/9781614486824.jpg?1718079009381",
      "alt": "This image is the cover for the book 87 Secrets of Outrageous Business Success"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("87 Secrets of Outrageous Business Success\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A treasury of tips from one of today’s most effective and experienced entrepreneurs!")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" From subscribers to his newsletters to readers of his many books, countless thousands have turned to Bob Bly for advice and inspiration on how to achieve success professionally, financially, and personally. In this volume, you get many years of Bob’s simple, proven advice compressed into a quick-reading guide to living a happy, fulfilling, and abundant life. You can achieve your goals, escape the rat race, and be master of your own destiny. In "), _c('i', [_vm._v("87 Secrets of Outrageous Business Success")]), _vm._v(", you will discover "), _c('br'), _vm._v("    Seven steps to outrageous business success  How to make yourself indispensable  Seven ways to command higher fees  How to become a more confident public speaker  Twenty-two undeniable truths of life  How to start your own home business after fifty  Four keys to success and happiness  How to get really good at anything  Ten ways to achieve Internet marketing success, and much more \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robert W. Bly\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Bob Bly is the author of eighty published books, including The Elements of Business Writing (Longman) and Start Your Own Home Business After 50 (Linden). He is a freelance copywriter with over thirty years experience in direct marketing; clients include PSE&G, IBM, AT&T, Medical Economics, Prentice Hall, and Kiplinger.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Morgan James Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0